import React, { memo } from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Las libretas de contraseñas se pierden, se desactualizan o son imposibles de entender para alguien más.', 'Confiar en la memoria es arriesgado; en momentos de crisis, los detalles importantes se olvidan.', 'Los programas de seguridad modernos son demasiado complicados, frustrantes y terminan siendo abandonados.', 'Decirle a un hijo "mi clave es el nombre de mi perro" no sirve de nada si el banco pide una verificación de dos pasos al celular bloqueado.'];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-20">
          Por qué lo que ha intentado hasta ahora no funciona
        </h2>

        <div className="space-y-6" data-id="element-21">
          {failures.map((text, index) => <div key={index} className="flex items-start gap-4 p-6 bg-cream rounded-sm border border-cream-dark" data-id="element-22">
              <XCircle className="w-8 h-8 text-burgundy shrink-0 mt-1" data-id="element-23" />
              <p className="text-xl text-charcoal" data-id="element-24">{text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}